module.exports = __webpack_public_path__ + "img/15.63203d4d.png";